export default "<p>wallet-settings works!</p>\n";